import { FlowsView } from 'assets/components/settings/components/sections/openingHours/views/flows';
export const SettingsBusinessHoursScheduleFlowsView = FlowsView;
